import {
    PixelObject
} from '../index.js'

export default class Image extends PixelObject {
    constructor(options) {
        super(options);

        const defaults = {
            type: 'IMAGE',
            name: 'Image',
            width: 50,
            height: 50,
            url: 'https://images.unsplash.com/photo-1643415701048-53d283681e25?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=830&q=80'
        }

        const opts = { ...defaults, ...options }

        this.type = opts.type
        this.name = opts.name
        this.width = opts.width
        this.height = opts.height
        this.isLoaded = opts.isLoaded
        this.loadingInProgress = opts.loadingInProgress
        this.image = opts.image
        this.url = opts.url

        this.load()
    }

    set(key, newValue) {
        let config = {
            url: () => {
                this.url = newValue
                this.isLoaded = false
                this.loadingInProgress = false
                this.image = null
                this.load()
                return this.url
            }
        }

        if (config[key]) {
            const oldValue = this[key]
            let parsedValue = config[key]({ newValue, oldValue })
            console.log(key, newValue, oldValue, parsedValue)
            if (oldValue != parsedValue) {
                this[key] = parsedValue
                this.dispatch('objectStateChanged', this.propertyChangedMessage(key))
            }
        } else {
            PixelObject.prototype.set.call(this, key, newValue)
        }
    }

    copy(args) {
        return new Image({ ...this, ...args, skipParentGeneration: true })
    }

    load() {
        if (this.isLoaded || this.loadingInProgress) return
        this.loadingInProgress = true
        this.ctx.print("Loading image...")
        this.ctx.loadImage(this.url, (img) => {
            console.log("Image loaded")
            this.image = img
            this.isLoaded = true
            this.loadingInProgress = false
            this.dispatch('objectStateChanged', this.propertyChangedMessage('Image loaded'))
        }, () => {
            console.log("Couldn't load image")
            this.isLoaded = true
            this.loadingInProgress = false
        })
    }

    draw() {
        if (this.visible == '0') return

        const width = this.getRenderPropertyValue('width')
        const height = this.getRenderPropertyValue('height')
        this.load()

        this.ctx.push()

        this.position()

        if (this.isLoaded) {
            if (this.opacity !== 100) {
                this.ctx.tint(255, 255 / 100 * this.opacity)
            }

            this.ctx.image(this.image, -width / 2, -height / 2, width, height);
        } else {
            this.ctx.rect(0, 0, width, height);
        }

        this.ctx.pop()
    }
}